import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import moment from 'moment';
import { get, keyBy } from 'lodash';
import CollectionLicensesTable from './CollectionLicensesTable';

export default class CollectionLicensesSection extends PureComponent {
    static propTypes = {
        updateCompanyExclusiveLearningAssetLicenses: PropTypes.func,
        getLicensedDate: PropTypes.func,
        trackLicensesByLicencedCollectionId: PropTypes.object.isRequired,
        availableCollections: PropTypes.arrayOf(PropTypes.object),
        currentValues: PropTypes.object,
        changeFormValue: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            selectedCollectionId: '',
            selectedCollection: {}
        };
    }

    /**
     *
     * @param collectionId
     * @returns {String}
     * @private
     */
    _getCollectionName = (collectionId) => get(this.props, `collectionsById[${collectionId}].name`, '');

    /**
     *
     * @param {Object} selectedObject
     * @private
     */
    _handleCollectionChange = (selectedObject) => {
        this.setState({
            selectedCollectionId: get(selectedObject, '_id', ''),
            selectedCollection: selectedObject
        });
    };

    /**
     *
     * @param {Object} fields
     * @param {Object} collection
     * @returns {*}
     */
    handleAddCollectionLicense = (fields, collection = {}) => {
        const { updateCompanyExclusiveLearningAssetLicenses } = this.props;

        if (collection && collection._id) {
            fields.push({
                collectionId: collection._id,
                collectionName: collection.name,
                licensedDateTime: moment.utc()
            });

            updateCompanyExclusiveLearningAssetLicenses(collection.contentIds || []);
        }
    };

    /**
     *
     * @param {Object} fields
     * @param {Number} index
     * @returns {*}
     */
    handleRemoveCollectionLicense = (fields, index) => {
        const { currentValues, changeFormValue, trackLicensesByLicencedCollectionId } = this.props;

        const currentTrackLicensesByLicencedCollectionId = { ...trackLicensesByLicencedCollectionId };
        const collectionLicenses = currentValues && currentValues.collectionLicenses;
        const defaultCollections = currentValues && currentValues.defaultCollections;
        const trackLicenses = currentValues && currentValues.trackLicenses;
        const trackLicensesByTrackId = keyBy(trackLicenses, 'trackId');
        const collectionToRemove = collectionLicenses[index];

        // Remove collection from licenses
        fields.remove(index);

        const licensedLearningAssetIdsToRemove = Object.keys(
            get(currentTrackLicensesByLicencedCollectionId, collectionToRemove.collectionId, [])
        );

        const licensedLearningAssetsToRemoveById = {};

        licensedLearningAssetIdsToRemove.forEach((assetId) => {
            // filter out any asset that is associated with another licensed collection
            if (currentTrackLicensesByLicencedCollectionId[collectionToRemove.collectionId][assetId].length === 1) {
                licensedLearningAssetsToRemoveById[assetId] = {
                    trackId: assetId,
                    trackName: trackLicensesByTrackId[assetId].trackName
                };
            }
        });

        if (licensedLearningAssetIdsToRemove.length) {
            changeFormValue({
                field: 'trackLicenses',
                value: trackLicenses.filter((trackLicense) => !licensedLearningAssetsToRemoveById[trackLicense.trackId])
            });
        }

        if (Array.isArray(defaultCollections) && defaultCollections.length) {
            const defaultCollectionLength = defaultCollections.length;
            let hasCollectionToBeRemoved = false;
            let indexToRemove = 0;

            for (let i = 0; i < defaultCollectionLength; i += 1) {
                if (defaultCollections[i].id === collectionToRemove.collectionId) {
                    hasCollectionToBeRemoved = true;
                    indexToRemove = i;
                    break;
                }
            }

            if (hasCollectionToBeRemoved) {
                const newDefaultCollections = [
                    ...defaultCollections.slice(0, indexToRemove),
                    ...defaultCollections.slice(indexToRemove + 1)
                ];
                changeFormValue({
                    field: 'defaultCollections',
                    value: newDefaultCollections
                });
            }
        }
    };

    render() {
        const { availableCollections, getLicensedDate, trackLicensesByLicencedCollectionId, currentValues } =
            this.props;
        const { selectedCollectionId, selectedCollection } = this.state;
        return (
            <div className={'collection-licenses-section'}>
                <label className={'form-label'}>Collection Licenses</label>
                <FieldArray
                    name={'collectionLicenses'}
                    currentValues={currentValues}
                    selectedCollectionId={selectedCollectionId}
                    selectedCollection={selectedCollection}
                    trackLicensesByLicencedCollectionId={trackLicensesByLicencedCollectionId}
                    availableCollections={availableCollections}
                    handleCollectionChange={this._handleCollectionChange}
                    handleAddCollectionLicense={this.handleAddCollectionLicense}
                    handleRemoveCollectionLicense={this.handleRemoveCollectionLicense}
                    getLicensedDate={getLicensedDate}
                    getCollectionName={this._getCollectionName}
                    component={CollectionLicensesTable}
                    trackLicensesByTrackId={keyBy(currentValues.trackLicenses, 'trackId')}
                />
            </div>
        );
    }
}
